import { Switch } from '@client/components/ui/switch';
import { Label } from '@client/components/ui/label';

interface AdminModeToggleProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export function AdminModeToggle({ enabled, onToggle }: AdminModeToggleProps) {
  return (
    <div className="flex items-center gap-2 min-w-fit">
      <Label htmlFor="admin-mode" className="text-sm font-medium cursor-pointer whitespace-nowrap">
        Admin Mode
      </Label>
      <Switch
        id="admin-mode"
        checked={enabled}
        onCheckedChange={onToggle}
      />
    </div>
  );
}

